export const SET_DRIVER_LOCATION = "SET_DRIVER_LOCATION"
export const SET_CUSTOMER_DOCKET_LOCATION = "SET_CUSTOMER_DOCKET_LOCATION"